import { getAllowedEmailDomain } from './auth-domain';

const STATIC = {
  'signin-incomplete': 'Sign-in did not complete. Please try again.',
  'signin-failed': 'Sign-in could not be completed. Please try again.',
  'oauth-error': 'Authentication provider returned an error. Please try again.',
  'domain-blocked': 'Your email domain is not authorized for this application.',
};

const FALLBACK = 'Something went wrong. Please try again.';

export function getAuthErrorMessage(code) {
  if (!code) return null;
  const template = STATIC[code];
  if (!template) return FALLBACK;
  return template.replace('DOMAIN', getAllowedEmailDomain());
}
